<template>
  <van-overlay :show="visible" :z-index="3000" :close-on-click-overlay="false" class="app-loading-overlay">
    <div class="loading-content" @touchmove.stop>
      <div class="loading-spinner">
        <!-- <div class="spinner-ring"></div>
        <div class="spinner-ring"></div> -->
        <div class="spinner-ring"></div>
      </div>
      <div v-if="message" class="loading-message">{{ message }}</div>
    </div>
  </van-overlay>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const visible = ref(false)
const message = ref('')

const show = (text: string = '') => {
  message.value = text
  visible.value = true
}

const hide = () => {
  visible.value = false
}

defineExpose({ show, hide })
</script>

<style scoped lang="scss">
.app-loading-overlay {
  background: rgba(0, 0, 0, 1) !important;
  // backdrop-filter: blur(4px);
  // -webkit-backdrop-filter: blur(4px);
}

.loading-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.loading-spinner {
  position: relative;
  width: 48px;
  height: 48px;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #fff;
  animation: spin 1.2s linear infinite;

  &:nth-child(1) {
    inset: 0;
    animation-delay: 0s;
  }

  &:nth-child(2) {
    inset: 6px;
    border-top-color: rgba(255, 255, 255, 0.7);
    animation-delay: -0.1s;
    animation-direction: reverse;
  }

  &:nth-child(3) {
    inset: 12px;
    border-top-color: rgba(255, 255, 255, 0.4);
    animation-delay: -0.2s;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loading-message {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  max-width: 200px;
  line-height: 1.4;
}
</style>
